import { Button, Dialog } from '@spiaggeit/spit-ui'
import { PropsWithChildren } from 'react'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'
import { INSERT_PERIOD_PATH } from '@/app/router/paths.ts'
import { useAppSelector } from '@/hooks/store.ts'
import { useAppPath } from '@/hooks/useAppPath.ts'
import { DialogWrapperProps } from '@/models/dialogWrapper.props.ts'
import { appSlice } from '@/store/appSlice'

export const LastSpotDialog = (
  props: PropsWithChildren<DialogWrapperProps>
) => {
  const { t } = useTranslation()
  const isPool = useAppSelector(appSlice.selectors.isPool)
  const insertPeriodPath = useAppPath(INSERT_PERIOD_PATH)
  const navigate = useNavigate()

  return (
    <Dialog
      isOpen={props.isOpen}
      scrollContent
      setIsOpen={props.setIsOpen}
      size="sm"
      title={t('map.lastAvailableSpotDialog.title')}
      trigger={null}
    >
      <div className="p-4">
        <p className="text-base">
          {t('map.lastAvailableSpotDialog.content', {
            context: isPool ? 'pool' : 'beach',
          })}
        </p>
        <div className="mb-2 mt-8 flex flex-col gap-2 pt-8 lg:flex-row-reverse">
          {props.children}

          <Button
            onClick={() => {
              props.setIsOpen(false)
              navigate(insertPeriodPath)
            }}
            variant="outline"
          >
            {t('map.lastAvailableSpotDialog.changeDates')}
          </Button>
        </div>
      </div>
    </Dialog>
  )
}
